import { render, staticRenderFns } from "./returns-icon.vue?vue&type=template&id=61dd6aeb"
import script from "./returns-icon.vue?vue&type=script&lang=js"
export * from "./returns-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports